import { notFound } from 'next/navigation';

import { getChannel, getDocument, getPlaceId, replaceDynamicData } from '@lib/server';
import type { Place } from '@types';

export async function getVenueOffersPageData(domain: string, venue: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const { placeId } = await getPlaceId(channel, venue);

  if (!placeId) notFound();

  const place = await getDocument<Place>('place', placeId, {
    tags: [channel.channelId],
    depth: 1,
    visibilityId: placeId,
    select: ['fields.custom.venueOffers', 'fields.name', 'fields.default', 'id'],
  });

  if (!place?.fields) notFound();

  const dynamicPlace = replaceDynamicData(place.fields);

  return dynamicPlace.custom?.venueOffers?.filter(Boolean);
}
